var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-navbar',{staticClass:"top-navbar",attrs:{"type":"light","variant":"light"}},[_c('b-navbar-nav',[_c('b-nav-text',{staticClass:"title-navbar"},[_vm._v(" "+_vm._s(_vm.$t("navbar.centrosEfectivo")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }